var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"input-styles",attrs:{"value":_vm.name,"rules":[_vm.requiredCheck],"label":_vm.label(),"height":"48","placeholder":" ","maxlength":"200","minlength":"2","outlined":"","persistent-placeholder":"","required":"","autofocus":_vm.autofocus},on:{"input":(val) => _vm.update(_vm.type, val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }